(function () {
  function scroller(el) {
    var e = el.parentElement;
    while (e && e !== document.documentElement) {
      var cs = getComputedStyle(e);
      if (/auto|scroll/.test(cs.overflowY) && e.scrollHeight > e.clientHeight) return e;
      e = e.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function kopfhoehe() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseInt(v, 10) || 0;
  }

  function start(root) {
    var links = [].slice.call(root.querySelectorAll('.obw-anchors a'));
    if (!links.length) return;
    var secs = links.map(function (a) {
      try { return root.querySelector(a.getAttribute('href')); } catch (e) { return null; }
    });
    if (!secs.filter(Boolean).length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = secs.indexOf(e.target);
          links.forEach(function (a, j) { a.classList.toggle('obw-is-current', i === j); });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      secs.forEach(function (s) { if (s) io.observe(s); });
    }

    var leiste = root.querySelector('.obw-anchors');
    links.forEach(function (a, i) {
      a.addEventListener('click', function (ev) {
        var ziel = secs[i];
        if (!ziel) return;
        ev.preventDefault();
        var box = scroller(ziel);
        var art = (document.visibilityState === 'visible' &&
                   !window.matchMedia('(prefers-reduced-motion: reduce)').matches)
                  ? 'smooth' : 'instant';
        var abstand = kopfhoehe() + (leiste ? leiste.offsetHeight : 0) + 12;
        var oben = ziel.getBoundingClientRect().top;
        if (box === document.scrollingElement || box === document.documentElement) {
          window.scrollTo({ top: oben + window.scrollY - abstand, behavior: art });
        } else {
          box.scrollTo({ top: box.scrollTop + oben - abstand, behavior: art });
        }
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });
  }

  function alle() {
    document.querySelectorAll('.obw').forEach(function (r) {
      if (r.dataset.obwInit) return;
      r.dataset.obwInit = '1';
      start(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);

(function () {
  function hot(root) {
    root.querySelectorAll('.obw-hot').forEach(function (box) {
      if (box.dataset.obwHotInit) return;
      box.dataset.obwHotInit = '1';
      var punkte = [].slice.call(box.querySelectorAll('.obw-hot__punkt'));
      var zeilen = [].slice.call(box.querySelectorAll('.obw-hot__liste li'));
      function zeige(i) {
        punkte.forEach(function (p, j) { p.setAttribute('aria-current', String(i === j)); });
        zeilen.forEach(function (z, j) {
          if (i === j) z.setAttribute('aria-current', 'true'); else z.removeAttribute('aria-current');
        });
      }
      punkte.forEach(function (p, i) {
        p.addEventListener('click', function () { zeige(i); });
        p.addEventListener('mouseenter', function () { zeige(i); });
      });
      zeilen.forEach(function (z, i) {
        z.addEventListener('mouseenter', function () { zeige(i); });
      });
      zeige(0);
    });
  }
  function alle() { document.querySelectorAll('.obw').forEach(hot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();

(function () {
  function vgl(root) {
    root.querySelectorAll('[data-obw-vgl]').forEach(function (box) {
      if (box.dataset.obwVglInit) return;
      box.dataset.obwVglInit = '1';
      var knoepfe = [].slice.call(box.querySelectorAll('[data-obw-ref-knopf]'));
      var label = box.querySelector('[data-obw-ref-label]');
      var name = box.querySelector('tspan[data-obw-ref-name]');
      knoepfe.forEach(function (k) {
        k.addEventListener('click', function () {
          var ziel = k.getAttribute('data-obw-ref-knopf');
          box.querySelectorAll('g[data-obw-ref]').forEach(function (g) {
            if (g.getAttribute('data-obw-ref') === ziel) g.removeAttribute('hidden');
            else g.setAttribute('hidden', '');
          });
          knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', String(x === k)); });
          if (label) label.textContent = k.getAttribute('data-obw-ref-norm');
          if (name) name.textContent = k.getAttribute('data-obw-ref-name');
        });
      });
    });
  }
  function alle() { document.querySelectorAll('.obw').forEach(vgl); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-obw-sprung]');
    if (!a) return;
    var ziel = document.querySelector(a.getAttribute('href'));
    if (!ziel) return;
    ev.preventDefault();
    var box = scroller(ziel);
    var kopf = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var art = document.visibilityState === 'visible' &&
              !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';
    var oben = ziel.getBoundingClientRect().top - kopf - 16;
    if (box === document.scrollingElement || box === document.documentElement) {
      window.scrollTo({ top: oben + window.scrollY, behavior: art });
    } else {
      box.scrollTo({ top: box.scrollTop + oben, behavior: art });
    }
    var fokus = ziel.querySelector('h1') || ziel;
    fokus.setAttribute('tabindex', '-1');
    fokus.focus({ preventScroll: true });
  });
})();
